module.exports = __webpack_public_path__ + "img/tc.985c0eeb.svg";